export default {
  renewing: "Renewing",
  subscription: "Subscription",
  upcomingBillingSummary: (plan: string, nextBillingDate: string): string =>
    `Summary of your new ${plan} subscription charges beginning on ${nextBillingDate}.`,
  upcomingBillingTitle: "Upcoming Billing"
};
